var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-page',{attrs:{"fluid":"lg","name":"loan"}},[_c('div',[_c('vue-headful',{attrs:{"title":_vm.fullTitle}}),_c('full-loan',{attrs:{"loan-id":_vm.id,"tab":_vm.tab}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }